import React from 'react'
import MenuItems from './MenuItems'

const Menu = () => {
  return <nav className="nav-menu d-none d-lg-block">
    <MenuItems />
  </nav>
}

export default Menu